import React, { PureComponent } from 'react';

class Forbidden extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            loginData: null
        };
    }

    render() {
        return (
            <div id="forbiddenPage">
                No permissions!
            </div>
        );
    }
}

export default Forbidden;
